// Botão 🎤 do ditado (0.65): toque para falar, toque de novo para parar. Não grava áudio.
import { useEffect, useRef, useState } from 'react';
import { Alert, Pressable, Text, View } from 'react-native';
import { C, alpha } from './theme';
import { t } from '../lib/i18n';
import { ditadoDisponivel, ouvir, type Sessao } from '../lib/ditado';

export function Ditado({ onTexto, cor, pequeno }: { onTexto: (t: string) => void; cor: string; pequeno?: boolean }) {
  const [ouvindo, setOuvindo] = useState(false);
  const [parcial, setParcial] = useState('');
  const sessao = useRef<Sessao | null>(null);
  const cb = useRef(onTexto); cb.current = onTexto;
  useEffect(() => () => sessao.current?.parar(), []);
  async function alternar() {
    if (ouvindo) { sessao.current?.parar(); sessao.current = null; setOuvindo(false); setParcial(''); return; }
    if (!ditadoDisponivel()) return Alert.alert(t('Ditado'), t('O ditado chega com a versão nova do app. Atualize o My Planner pela loja para usar o microfone.'));
    setOuvindo(true);
    sessao.current = await ouvir(tx => { setParcial(''); cb.current(tx); }, erro => {
      setOuvindo(false); setParcial(''); sessao.current = null;
      if (erro === 'permissao') Alert.alert(t('Microfone'), t('Permita o microfone e o reconhecimento de fala para o My Planner nos ajustes do celular.'));
      else if (erro && !['aborted', 'no-speech', 'speech-timeout'].includes(erro)) Alert.alert(t('Ditado'), t('Não foi possível ouvir agora ({erro}).', { erro }));
    }, setParcial);
    if (!sessao.current) setOuvindo(false);
  }
  return (
    <View style={{ flexDirection: 'row', alignItems: 'center', gap: 6 }}>
      <Pressable onPress={alternar} hitSlop={8} accessibilityLabel={ouvindo ? t('Parar o ditado') : t('Ditar (falar para escrever)')}
        style={{ width: pequeno ? 30 : 34, height: pequeno ? 28 : 30, borderRadius: 15, alignItems: 'center', justifyContent: 'center', backgroundColor: ouvindo ? C.danger : alpha(cor, 0.18) }}>
        <Text style={{ fontSize: pequeno ? 14 : 16 }}>{ouvindo ? '⏹' : '🎤'}</Text>
      </Pressable>
      {ouvindo && <Text style={{ color: C.danger, fontSize: 11, maxWidth: 160 }} numberOfLines={1}>{parcial || t('Ouvindo…')}</Text>}
    </View>
  );
}
